import { useMinicrudsPermission } from '../../helpers/minicrudsPermission'
import { useOpenEditMinicrudModal } from '../../routes/modals/modalsActions'
import { useRemoveMinicruds } from './_requests/removeMinicruds'
import { useRouteParam } from '../../routes/helpers/useParam'

export const useMinicrudEditAction = item => {
  const openEditModal = useOpenEditMinicrudModal()
  const canEdit = useMinicrudsPermission(item?.entity)

  return {
    click: () => openEditModal({ id: item?.id, entity: item?.entity }),
    hasPermission: canEdit
  }
}

export const useMinicrudRemoveAction = item => {
  const canDelete = useMinicrudsPermission(item?.entity)
  const [deleteItems, { loading }] = useRemoveMinicruds()

  return {
    click: () => deleteItems([item.id]),
    hasPermission: canDelete
  }
}

export const useMinicrudsRemoveAction = ids => {
  const entity = useRouteParam('entity')
  const canDelete = useMinicrudsPermission(entity)
  const [deleteItems, { loading }] = useRemoveMinicruds()

  return {
    click: () => deleteItems(ids),
    hasPermission: canDelete
  }
}
